import { render } from "./reducirreservas.vue?vue&type=template&id=4745e10c&scoped=true"
import script from "./reducirreservas.vue?vue&type=script&lang=js"
export * from "./reducirreservas.vue?vue&type=script&lang=js"

import "./reducirreservas.vue?vue&type=style&index=0&id=4745e10c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4745e10c"]])

export default __exports__